//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  emits: ['chooseTagFromQuestion'],
  data() {
    return {
    }
  },
  props: {
    question: {
      type: Object,
      required: false,
    }
  },
  computed: {
     publicationDate() {
      const unixDate = this.question?.created_at
      const date = new Date(unixDate * 1000)

      const dd = `${date.getDate()}`.padStart(2, '0');
      //const mm = `${date.getMonth() + 1}`.padStart(2, '0');
      const mm = date.getMonth() + 1;
      const yyyy = `${date.getFullYear()}`;

      let mmWord = null;
      if (mm === 1) {
        mmWord = 'Января'
      }
      if (mm === 2) {
        mmWord = 'Февраля'
      }
      if (mm === 3) {
        mmWord = 'Марта'
      }
      if (mm === 4) {
        mmWord = 'Апреля'
      }
      if (mm === 5) {
        mmWord = 'Мая'
      }
      if (mm === 6) {
        mmWord = 'Июня'
      }
      if (mm === 7) {
        mmWord = 'Июля'
      }
      if (mm === 8) {
        mmWord = 'Августа'
      }
      if (mm === 9) {
        mmWord = 'Сентября'
      }
      if (mm === 10) {
        mmWord = 'Октября'
      }
      if (mm === 11) {
        mmWord = 'Ноября'
      }
      if (mm === 12) {
        mmWord = 'Декабря'
      }

      return `${dd} ${mmWord} ${yyyy}`
    },
    specialist: function() {
      return this.question?.specialist || '';
    },

    questionTitle: function () {
       return this.question?.question_title || ""
    },
    questionTags: function () {
       return this.question?.tags || []
    }
  },
  methods: {
    openSwiperPopup: function(images, activeIndex) {
      this.$store.commit(
        "swiper-popup/openSwiperPopup",
        {
          images: images,
          activeIndex: activeIndex,
        }
      )
    }
  },
}
